<template>
	<router-view></router-view>
</template>
<script>
export default {
	name: 'page-job-evaluation',
	mounted() {
		const sectionContainer = document.querySelector('.section-margin');
		sectionContainer.classList.add('section-margin-full');
	},
	beforeDestroy() {
		const sectionContainer = document.querySelector('.section-margin');
		if (sectionContainer) {
			sectionContainer.classList.remove('section-margin-full');
		}
	},
};
</script>



// WEBPACK FOOTER //
// src/modules/job-evaluation/pages/page-job-evaluation.vue